// extracted by mini-css-extract-plugin
export default {"photo":"WSVirtualAssistant_photo__A+7um","card":"WSVirtualAssistant_card__XnBg-","msg":"WSVirtualAssistant_msg__affxt"};